"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEndpoint = void 0;
const authenticated_1 = require("../../clients/handlers/aws/authenticated");
const composeServiceApi_1 = require("../../clients/internal/composeServiceApi");
const extendedEncodeURIComponent_1 = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
const serde_1 = require("../../clients/serde");
const amplifyUrl_1 = require("../../utils/amplifyUrl");
const base_1 = require("./base");
const updateEndpointSerializer = ({ ApplicationId = '', EndpointId = '', EndpointRequest }, endpoint) => {
    const headers = (0, base_1.getSharedHeaders)();
    const url = new amplifyUrl_1.AmplifyUrl(endpoint.url);
    url.pathname = `v1/apps/${(0, extendedEncodeURIComponent_1.extendedEncodeURIComponent)(ApplicationId)}/endpoints/${(0, extendedEncodeURIComponent_1.extendedEncodeURIComponent)(EndpointId)}`;
    const body = JSON.stringify(EndpointRequest);
    return { method: 'PUT', headers, url, body };
};
const updateEndpointDeserializer = async (response) => {
    if (response.statusCode >= 300) {
        const error = await (0, serde_1.parseJsonError)(response);
        throw error;
    }
    else {
        const { Message, RequestID } = await (0, serde_1.parseJsonBody)(response);
        return {
            MessageBody: {
                Message,
                RequestID,
            },
            $metadata: (0, serde_1.parseMetadata)(response),
        };
    }
};
/**
 * @internal
 */
exports.updateEndpoint = (0, composeServiceApi_1.composeServiceApi)(authenticated_1.authenticatedHandler, updateEndpointSerializer, updateEndpointDeserializer, base_1.defaultConfig);
